import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import MatrixTree from '../components/matrix/MatrixTree';
import PackageSelector from '../components/matrix/PackageSelector';
import ConnectButton from '../components/common/ConnectButton';
import Loader from '../components/common/Loader';

const Matrix = () => {
  const { connected } = useWallet();
  const { userId, user, initialLoading, isRegistered } = useUserData();
  const [selectedPkg, setSelectedPkg] = useState(1);

  if (!connected) {
    return (
      <div className="main-content">
        <div className="connect-prompt">
          <div className="connect-prompt-icon">🔗</div>
          <h2>Connect Your Wallet</h2>
          <div className="mt-lg"><ConnectButton /></div>
        </div>
      </div>
    );
  }

  if (initialLoading) return <Loader text="Loading Matrix" />;
  if (!isRegistered) return <Navigate to="/register" replace />;

  const topPkg = user?.topPackageId || 0;

  if (topPkg === 0) {
    return (
      <div className="main-content">
        <div className="page-header">
          <h1 className="page-title">Matrix</h1>
        </div>
        <div className="empty-state">
          <div className="empty-state-icon">📦</div>
          <div>Activate a package to view your matrix</div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-content">
      <div className="page-header">
        <h1 className="page-title">Matrix</h1>
        <p className="page-subtitle">Your matrix placement across packages</p>
      </div>

      <div className="mb-lg">
        <div className="mb-md text-muted" style={{ fontSize: 13 }}>Select a package:</div>
        <PackageSelector
          selected={selectedPkg}
          onChange={setSelectedPkg}
          maxPackage={topPkg}
        />
      </div>

      <MatrixTree userId={userId} packageId={selectedPkg} />
    </div>
  );
};

export default Matrix;
